import createComponent from 'styles/fela/createComponent';
import { ieInputHideClearIcon } from 'styles/fela/mixins';
import { SearchIcon } from 'components/Icons';

export const SearchWrapper = createComponent(({ fullWidth }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  position: 'relative',
  ...(!fullWidth ? {
    width: '15rem',
  } : null),
}), 'div', ['fullWidth']);

export const InputWrapper = createComponent(() => ({
  alignItems: 'center',
  display: 'flex',
}), 'div', ['textColor']);

export const SearchIconStyled = createComponent(() => ({
  flexShrink: 0,
}), SearchIcon, []);

export const Input = createComponent(({ fixedFontSize }) => ({
  backgroundColor: 'transparent',
  border: '0',
  color: 'inherit',
  ...(fixedFontSize ? { fontSize: '16px' } : {}),
  margin: '0',
  outline: '0',
  padding: '0 0 0px 20px',
  width: '100%',
  // Ensure the input doesn't collapse below a usable width.
  // This replaces the invisible "Search" placeholder text hack.
  minWidth: '60px',
  '::placeholder': {
    color: 'inherit',
    opacity: 0.8,
  },
  ...ieInputHideClearIcon(),
}), 'input', ['autoFocus', 'fixedFontSize']);

